<template>
  <div>
    <OtherHeader :img_header="header_image" header="คำถามใหม่" link_back="faqspage"/>
    <Faqs_add/>
  </div>
</template>

<script>
import OtherHeader from "@/components/admin/manage_website/other_setting/menu_other/OtherHeader";
import Faqs_add from "@/components/admin/manage_website/other_setting/Faqs_add";
import HeaderImage from "@/assets/faqs.png";
export default {
  name: "FaqsAdd",
  components: {
    Faqs_add,
    OtherHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
